import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ_COUNT = 3;

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: Array.from({ length: FAQ_COUNT }, (_, idx) => ({
              '@type': 'Question',
              name: t(`seminar.faq.${idx}.question`),
              acceptedAnswer: {
                '@type': 'Answer',
                text: t(`seminar.faq.${idx}.answer`),
              },
            })),
          }),
        }}
      />

      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[800px] mx-auto px-8">
          <div className="text-center mb-14">
            {String(t('seminar.faq.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
              {t('seminar.faq.title')}
            </h2>
            <div className="gold-line mx-auto"></div>
          </div>

          <div className="space-y-3">
            {Array.from({ length: FAQ_COUNT }, (_, index) => (
              <div key={index} className="border border-background-200/60">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-background-100/50 transition-colors duration-200"
                  aria-expanded={openIndex === index}
                >
                  <span className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] pr-4">
                    {t(`seminar.faq.${index}.question`)}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={[
                        'text-sm text-accent-600 transition-transform duration-300',
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line',
                      ].join(' ')}
                    ></i>
                  </span>
                </button>
                <div
                  className={[
                    'overflow-hidden transition-all duration-300',
                    openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0',
                  ].join(' ')}
                >
                  <div className="px-6 pb-5 pt-0">
                    <div className="border-t border-background-200/40 pt-4">
                      <p className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                        {t(`seminar.faq.${index}.answer`)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {String(t('seminar.faq.footer')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">{__s}</p>))}
        </div>
      </section>
    </>
  );
}
